import { endOfMonth, isAfter } from 'date-fns';
import padStart from 'lodash/padStart';
import { toDate } from 'lib/utils';

export interface CreditCardExpiry {
  expiryMonth?: string;
  expiryYear?: string;
}

// TODO: move to graphql field on CreditCardPaymentMethod
export const isCreditCardExpired = (now: number | Date, { expiryMonth, expiryYear }: CreditCardExpiry) => {
  if (!expiryMonth || !expiryYear) {
    return false;
  }

  const year = padStart(expiryYear, 4, '20');
  const month = padStart(expiryMonth, 2, '0');
  const expiryDate = endOfMonth(toDate(`${year}-${month}-01`));

  return isAfter(now, expiryDate);
};
